import React, { useState, useEffect } from "react";
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Loader from "../../Global/Loader";

function EducationForm({
    educationData, 
    setActiveEducationPage, 
    getUserDetails,
    educationRecordAction,
    setEducationRecordAction
  }) {

  const [isFormValid, setIsFormValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    qualificationLevel: "",
    incompleteEducation: false,
    // currentlyEnrolled: false,
    startDate: "",
    endDate: "",

    instituteCountry: "",
    instituteCity: "",
    instituteName: "",
    programTitle: "",
    campus: "",
    department: "",
    registrationNumber: "",
    educationSystem: "",
    major: "",

    gradingSystem: "",
    total: "",
    obtained: "",
  });

  useEffect(() => {
    setFormData({...educationData });
  }, []);

  useEffect(() => {
    // Base required fields
    let requiredFields = [
      "qualificationLevel",
      "startDate",
      "endDate",
      "instituteCountry",
      "instituteCity",
      "instituteName",
      "programTitle",
      "campus",
      "department",
      "registrationNumber",
      "educationSystem",
      "major",
      "gradingSystem",
      "obtained",
    ];
  
    // Add `total` only if gradingSystem is not "Percentage"
    if (formData.gradingSystem !== "Percentage") {
      requiredFields.push("total");
    }
  
    // Validate the form
    const isValid = requiredFields.every((field) => formData[field]?.trim() !== "");
    setIsFormValid(isValid);
  }, [formData]);

  const updateEducation = async () => {
    try {
      // console.log("educationId: ", educationData._id);
      setIsLoading(true);
      const response = await axios.patch(`${process.env.REACT_APP_BASE_URL}/student/education/${educationData._id}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (response?.data?.success) {
        setIsLoading(false);
        getUserDetails();
        setActiveEducationPage('');
      }
    } catch (error) {
      // console.log(error);
      setError(error.response?.data?.message || "Something went wrong.");
      setIsLoading(false);
    }finally {
      setIsLoading(false);
    }
  }
  

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
  
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  
  const handleSubmit = (e) => {
    e.preventDefault();
  
    // console.log("Form Data Prepared for Submission:", formData);
  
    // Call the API to add new education
    updateEducation();
  };

  
  useGSAP(()=>{
    const fields = document.querySelectorAll(".relative");
  
    fields.forEach((field) => {
      const input = field.querySelector("input, select");
      const label = field.querySelector("label");
      const pLabel = field.querySelector("p"); // Error message <p> element (optional)
  
      if (!input || !label) {
        // console.warn("Missing input or label in field:", field);
        return; // Skip this field if input or label is missing
      }

      // Automatically move label to the top if the input already has a value
      if (input.value !== "") {
        gsap.to(label, { top: -10, fontSize: "0.70rem", color: "#6b7280", duration: 0.25 }); // Set label to gray initially
        gsap.to(input, { borderColor: "#6b7280", duration: 0.25 }); // Set border to gray initially
        if (pLabel) {
          pLabel.textContent = `Please enter your ${label.textContent.toLowerCase()}`;
          pLabel.classList.remove("text-red-500");
          pLabel.classList.add("text-gray-500");
        }
      }
    })
    
  }, [formData, educationRecordAction])
  
  
  useGSAP(() => {
    const fields = document.querySelectorAll(".relative");
  
    fields.forEach((field) => {
      const input = field.querySelector("input, select");
      const label = field.querySelector("label");
      const pLabel = field.querySelector("p"); // Error message <p> element (optional)
  
      if (!input || !label) {
        // console.warn("Missing input or label in field:", field);
        return; // Skip this field if input or label is missing
      }
  
  
      // Add focus event listener
      input.addEventListener("focus", () => {
        gsap.to(label, { top: -10, fontSize: "0.70rem", color: "#22c55e", duration: 0.25 }); // Set label to green
        gsap.to(input, { borderColor: "#22c55e", duration: 0.25 }); // Set border to green
        if (pLabel) {
          pLabel.classList.remove("text-red-500"); // Remove red error text
          pLabel.classList.add("text-gray-500"); // Set label text color to gray
        }
      });
  
      // Add input event listener
      input.addEventListener("input", () => {
        if (input.value !== "") {
          gsap.to(label, { color: "#22c55e", duration: 0.25 }); // Keep label green while typing
          gsap.to(input, { borderColor: "#22c55e", duration: 0.25 }); // Keep border green while typing
          if (pLabel) {
            pLabel.classList.remove("text-red-500"); // Remove red error message
            pLabel.classList.add("text-gray-500"); // Normal label text
          }
        }
      });
  
      // Add blur event listener
      input.addEventListener("blur", () => {
        if (input.value === "") {
          // Field is empty: Show error styles
          gsap.to(label, { top: 10, fontSize: "1rem", color: "#6b7280", duration: 0.25 });
          gsap.to(input, { borderColor: "#ef4444", duration: 0.25 });
          input.classList.add("error-border"); // Red border when field is empty
          if (pLabel) {
            pLabel.textContent = `${label.textContent} Required *`; // Update error message
            pLabel.classList.add("text-red-500"); // Set error message text to red
          }
        } else {
          // Field has a value: Keep green styles
          input.classList.remove("error-border");
          gsap.to(input, { borderColor: "#6b7280", duration: 0.25 }); // set gray border
          gsap.to(label, { color: "#6b7280", duration: 0.25 }); // set gray label
          if (pLabel) {
            pLabel.textContent = `Please enter your ${label.textContent.toLowerCase()}`;
            pLabel.classList.remove("text-red-500"); // Remove red error message
            pLabel.classList.add("text-gray-500"); // Set label text color to gray
          }
        }
      });
    });
  }, [formData]);

  return (
    <div className="flex flex-col space-y-6 w-[72%]">
      {isLoading && <Loader />}
      {
        error && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white w-full max-w-md mx-auto rounded-lg shadow-lg p-6">
              {/* Modal Content */}
              <h2 className="text-lg font-semibold text-gray-800 mb-4">
                Something went wrong!
              </h2>
              <h4 className="text-sm text-gray-600 mb-6">
                We encountered an issue while processing your request. Please try again later. If the problem persists, contact support.
              </h4>
              <div className="flex justify-end space-x-4">                
                {/* Proceed Button */}
                <button
                  onClick={() => {
                    setError(null);
                    setActiveEducationPage("");
                  }}
                  className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 focus:outline-none"
                >
                  Okay
                </button>
              </div>
            </div>
          </div>
        )
      }
      {educationRecordAction === 'edit' && <div className="px-10 py-6 bg-white rounded shadow-lg">
        <h2 className="text-gray-800 text-lg font-semibold mb-4">Education Details</h2>
        <hr className="border-t border-gray-300 mb-8" />

        <h2 className="text-gray-800 text-md font-semibold mb-4">Qualification Details</h2>
        <hr className="border-t border-gray-300 mb-8" />

        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6 mt-6">
            <div className="relative">
              <label
                htmlFor="qualificationLevel"
                className="absolute text-sm text-gray-500 transform top-2 left-3 bg-white px-1"
              >
                Qualification Level
              </label>
              <select
                id="qualificationLevel"
                name="qualificationLevel"
                className="w-full p-2 border rounded"
                value={formData.qualificationLevel}
                onChange={handleChange}
              >
                <option value=""></option>
                <option value="Secondary School Certificate/ Matriculation/ O - level">SSC/ Matriculation/ O - level</option>
                <option value="Higher Secondary School Certificate/ Intermediate/ A - level">HSSC/ Intermediate/ A - level</option>
                <option value="CA/ ACCA">CA/ ACCA</option>
                <option value="Bachelor (14 Years) Degree">Bachelor (14 Years) Degree</option>
                <option value="Bachelor (15 Years) Degree">Bachelor (15 Years) Degree</option>
                <option value="Bachelor (16 Years) Degree">Bachelor (16 Years) Degree</option>
                <option value="Master (16 Years) Degree">Master (16 Years) Degree</option>
                <option value="Master (17 Years) Degree">Master (17 Years) Degree</option>
                <option value="Master/ MS (18 Years) Degree">Master/ MS (18 Years) Degree</option>
              </select>
              <span className="text-gray-500 text-xs mt-1">Please select qualification</span>
            </div>

            <div className="flex items-center space-x-4 mb-5">
              <div className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  className="form-checkbox h-4 w-4 text-blue-500 border-gray-300 rounded"
                  name="incompleteEducation"
                  checked={formData.incompleteEducation}
                  onChange={handleChange}
                />
                <span className="text-gray-700 text-md">Currently Enrolled</span>
              </div>

              {/* <div className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  className="form-checkbox h-4 w-4 text-blue-600 border-gray-300 rounded"
                  name="currentlyEnrolled"
                  checked={formData.currentlyEnrolled}
                  onChange={handleChange}
                />
                <span className="text-gray-700 text-md">Currently Enrolled</span>
              </div> */}
            </div>

            <div className="relative">
              <label
                htmlFor="start"
                className="absolute text-sm text-gray-500 transform top-2 left-3 bg-white px-1"
              >
                Start Date
              </label>
              <input
                id="start"
                type="date"
                className={`w-full p-2 border rounded ${!formData.startDate && 'text-transparent'}`}
                name="startDate"
                value={formData.startDate.split("T")[0]}
                onChange={handleChange}
              />
              <span className="text-gray-500 text-xs mt-1">Please select start date</span>
            </div>

            <div className="relative">
              <label
                htmlFor="end"
                className="absolute text-sm text-gray-500 transform top-2 left-3 bg-white px-1"
              >
                End Date/ Expected End Date
              </label>
              <input
                id="end"
                type="date"
                className={`w-full p-2 border rounded ${!formData.endDate && 'text-transparent'}`}
                name="endDate"
                value={formData.endDate.split("T")[0]}
                onChange={handleChange}
              />
              <span className="text-gray-500 text-xs mt-1">Please select end date</span>
            </div>
          </div>

          <hr className="border-t border-gray-300 mb-8" />
          <h2 className="text-gray-800 text-md font-semibold mb-4">
            Degree / Certificate Awarding Institute Details
          </h2>
          <hr className="border-t border-gray-300 mb-8" />

          {/* Degree / Certificate Awarding Institute Details */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
            {/* instituteCountry */}
            <div className="relative">
              <label htmlFor="instituteCountry" className="absolute text-sm text-gray-500 transform top-2 left-3 bg-white px-1">
                Country
              </label>
              <input
                id="instituteCountry"
                name="instituteCountry"
                value={formData.instituteCountry}
                onChange={handleChange}
                className="w-full p-2 border rounded"
              >
                
              </input>
              <span className="text-gray-500 text-xs mt-1">Please enter country of the institute</span>
            </div>

            {/* instituteCity */}
            <div className="relative">
              <label htmlFor="instituteCity" className="absolute text-sm text-gray-500 transform top-2 left-3 bg-white px-1">
                City
              </label>
              <input
                id="instituteCity"
                name="instituteCity"
                value={formData.instituteCity}
                onChange={handleChange}
                className="w-full p-2 border rounded"
              >
              </input>
              <span className="text-gray-500 text-xs mt-1">Please enter city of the institute</span>
            </div>

            {/* Degree Awarding Institute */}
            <div className="relative">
              <label
                htmlFor="instituteName"
                className="absolute text-sm text-gray-500 transform top-2 left-3 bg-white px-1"
              >
                Degree Awarding Institute
              </label>
              <input
                id="instituteName"
                name="instituteName"
                value={formData.instituteName}
                onChange={handleChange}
                className="w-full p-2 border rounded"
              >
              </input>
              <span className="text-gray-500 text-xs mt-1">Please enter the name of the institute</span>
            </div>
          </div>

          {/* Program Details */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
            {/* Program Title */}
            <div className="relative">
              <label
                htmlFor="programTitle"
                className="absolute text-sm text-gray-500 transform top-2 left-3 bg-white px-1"
              >
                Program Title
              </label>
              <input
                id="programTitle"
                name="programTitle"
                type="text"
                value={formData.programTitle}
                onChange={handleChange}
                className="w-full p-2 border rounded"
              />
              <span className="text-gray-500 text-xs mt-1">Please enter program title</span>
            </div>

            {/* Campus */}
            <div className="relative">
              <label htmlFor="campus" className="absolute text-sm text-gray-500 transform top-2 left-3 bg-white px-1">
                Campus
              </label>
              <input
                id="campus"
                name="campus"
                type="text"
                value={formData.campus}
                onChange={handleChange}
                className="w-full p-2 border rounded"
              />
              <span className="text-gray-500 text-xs mt-1">Please enter campus</span>
            </div>

            {/* Department */}
            <div className="relative">
              <label htmlFor="department" className="absolute text-sm text-gray-500 transform top-2 left-3 bg-white px-1">
                Department
              </label>
              <input
                id="department"
                name="department"
                type="text"
                value={formData.department}
                onChange={handleChange}
                className="w-full p-2 border rounded"
              />
              <span className="text-gray-500 text-xs mt-1">Please enter department</span>
            </div>
          </div>

          {/* Academic Information */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
            {/* Degree Type */}
            <div className="relative">
              <label htmlFor="registrationNumber" className="absolute text-sm text-gray-500 transform top-2 left-3 bg-white px-1">
                Registration/Roll Number
              </label>
              <input
                id="registrationNumber"
                name="registrationNumber"
                value={formData.registrationNumber}
                onChange={handleChange}
                className="w-full p-2 border rounded"
              >
              </input>
              <span className="text-gray-500 text-xs mt-1">Please enter registration/roll number</span>
            </div>

            {/* Session Type */}
            <div className="relative">
              <label htmlFor="educationSystem" className="absolute text-sm text-gray-500 transform top-2 left-3 bg-white px-1">
                Education System
              </label>
              <select
                id="educationSystem"
                name="educationSystem"
                value={formData.educationSystem}
                onChange={handleChange}
                className="w-full p-2 border rounded"
              >
                <option value=""></option>
                <option value="Annual">Annual</option>
                <option value="Semester">Semester</option>
                <option value="Semester">Term</option>
              </select>
              <span className="text-gray-500 text-xs mt-1">Please select education system</span>
            </div>

            {/* Major */}
            <div className="relative">
              <label htmlFor="major" className="absolute text-sm text-gray-500 transform top-2 left-3 bg-white px-1">
                Major
              </label>
              <input
                id="major"
                name="major"
                value={formData.major}
                onChange={handleChange}
                className="w-full p-2 border rounded"
              >
              </input>
              <span className="text-gray-500 text-xs mt-1">Please select major</span>
            </div>
          </div>

          {/* Academic Performance Details */}
          <hr className="border-t border-gray-300 mb-8" />
          <h2 className="text-gray-800 text-md font-semibold mb-4">Academic Performance Details</h2>
          <hr className="border-t border-gray-300 mb-8" />

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
            {/* Grading System */}
            <div className="relative">
              <label
                htmlFor="gradingSystem"
                className="absolute text-sm text-gray-500 transform top-2 left-3 bg-white px-1"
              >
                Grading System
              </label>
              <select
                id="gradingSystem"
                name="gradingSystem"
                value={formData.gradingSystem}
                onChange={handleChange}
                className="w-full p-2 border rounded"
              >
                <option value=""></option>
                <option value="CGPA Based">CGPA Based</option>
                <option value="Percentage">Percentage</option>
                <option value="Marks">Marks</option>
              </select>
              <span className="text-gray-500 text-xs mt-1">Please select grading system</span>
            </div>

            {/* Total */}
            {formData.gradingSystem === "CGPA Based" || formData.gradingSystem === "Marks" ? (
              <div className="relative">
                <label
                  htmlFor="total"
                  className="absolute text-sm text-gray-500 transform top-2 left-3 bg-white px-1"
                >
                  {formData.gradingSystem === "CGPA Based"
                    ? "Total CGPA"
                    : "Total Marks"}
                </label>
                <input
                  id="total"
                  name="total"
                  type="number"
                  value={formData.total}
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                />
                <span className="text-gray-500 text-xs mt-1">
                  {formData.gradingSystem === "CGPA Based"
                    ? "Please enter total CGPA"
                    : "Please enter total marks"}
                </span>
              </div>
            ) : null}

            {/* Obtained */}
            {formData.gradingSystem && (
              <div className="relative">
                <label
                  htmlFor="obtained"
                  className="absolute text-sm text-gray-500 transform top-2 left-3 bg-white px-1"
                >
                  {formData.gradingSystem === "CGPA Based"
                    ? "Obtained CGPA"
                    : formData.gradingSystem === "Marks"
                    ? "Obtained Marks"
                    : "Obtained Percentage"}
                </label>
                <input
                  id="obtained"
                  name="obtained"
                  type="number"
                  value={formData.obtained}
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                />
                <span className="text-gray-500 text-xs mt-1">
                  {formData.gradingSystem === "CGPA Based"
                    ? "Please enter obtained CGPA"
                    : formData.gradingSystem === "Marks"
                    ? "Please enter obtained marks"
                    : "Please enter obtained percentage"}
                </span>
              </div>
            )}

          </div>

          <div className="justify-end items-end text-right mt-6">
            <button
              type="submit"
              disabled={!isFormValid}
              className={`${
                isFormValid
                  ? "bg-white text-blue-500 border-blue-500 hover:bg-blue-500 hover:text-white cursor-pointer"
                  : "bg-white text-blue-200 border-blue-200 cursor-not-allowed"
              } border px-4 py-2 rounded`}
            >
              Update Education
            </button>
          </div>
        </form>
      </div>}
      {educationRecordAction === 'view' &&
      <>
        <div className="px-10 py-6 bg-white rounded shadow-lg">
          <div className="flex justify-end absolute right-24">
            <button onClick={()=> setEducationRecordAction('edit')}>
              <i className="fas fa-edit font-thin"></i>
            </button>
          </div>
          {/* Education Details */}
          <h2 className="text-gray-800 text-lg font-semibold mb-4">
            Education Details
          </h2>
          <hr className="border-t border-gray-300 mb-8" />
        
          {/* Qualification Details Section */}
          <div className="mb-8">
            <h2 className="text-gray-800 text-lg font-semibold mb-4">
              Qualification Details
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {/* Qualification Level */}
              <div className="p-4">
                <span className="text-gray-800 text-base font-semibold">
                  Qualification Level
                </span>
                <span className="text-gray-900 mt-1"><br/>{educationData.qualificationLevel}</span>
              </div>
        
              {/* Education Status */}
              <div className="p-4">
                <span className="text-gray-800 text-base font-semibold">
                  Education Status
                </span>
                <div className="flex gap-4 mt-1">
                {educationData.incompleteEducation === false ? (
                  <span className="text-gray-900">
                    <i className="fas fa-check-circle text-green-500 mr-2"></i>
                    Complete
                  </span>
                ) : educationData.incompleteEducation === true ? (
                  <span className="text-gray-900">
                    <i className="fas fa-university text-blue-500 mr-2"></i>
                    Currently Enrolled
                  </span>
                ) : null }

                </div>
              </div>
        
              {/* Duration */}
              <div className="p-4">
                <span className="text-gray-800 text-base font-semibold">
                  Start Date
                </span>
                <span className="text-gray-900 mt-1"><br/>{educationData.startDate.split("T")[0]}</span>
              </div>
        
              <div className="p-4">
                <span className="text-gray-800 text-base font-semibold">
                  End Date
                </span>
                <span className="text-gray-900 mt-1"><br/>{educationData.endDate.split("T")[0]}</span>
              </div>
            </div>
          </div>
          <hr className="border-t border-gray-300 mb-4" />
        
          {/* Institute Details Section */}
          <div className="mb-8">
            <h2 className="text-gray-800 text-lg font-semibold mb-4">
              Degree / Certificate Awarding Institute Details
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="p-4">
                <span className="text-gray-800 text-base font-semibold">
                  Country
                </span>
                <span className="text-gray-900 mt-1"><br/>{educationData.instituteCountry}</span>
              </div>
        
              <div className="p-4">
                <span className="text-gray-800 text-base font-semibold">City</span>
                <span className="text-gray-900 mt-1"><br/>{educationData.instituteCountry}</span>
              </div>
        
              <div className="p-4">
                <span className="text-gray-800 text-base font-semibold">
                  Institute
                </span>
                <span className="text-gray-900 mt-1"><br/>{educationData.instituteName}</span>
              </div>
            </div>
        
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-6">
              <div className="p-4">
                <span className="text-gray-800 text-base font-semibold">
                  Program Title
                </span>
                <span className="text-gray-900 mt-1"><br/>{educationData.programTitle}</span>
              </div>
        
              <div className="p-4">
                <span className="text-gray-800 text-base font-semibold">Campus</span>
                <span className="text-gray-900 mt-1"><br/>{educationData.campus}</span>
              </div>
        
              <div className="p-4">
                <span className="text-gray-800 text-base font-semibold">
                  Department
                </span>
                <span className="text-gray-900 mt-1"><br/>{educationData.department}</span>
              </div>
            </div>
          </div>
          <hr className="border-t border-gray-300 mb-4" />
        
          {/* Academic Details Section */}
          <div className="mb-8">
            <h2 className="text-gray-800 text-lg font-semibold mb-4">
              Academic Details
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        
              <div className="p-4">
                <span className="text-gray-800 text-base font-semibold">Major</span>
                <span className="text-gray-900 mt-1"><br/>{educationData.major}</span>
              </div>

              <div className="p-4">
                <span className="text-gray-800 text-base font-semibold">
                  Registration/Roll Number
                </span>
                <span className="text-gray-900 mt-1"><br/>{educationData.registrationNumber}</span>
              </div>

              <div className="p-4">
                <span className="text-gray-800 text-base font-semibold">
                  Education System
                </span>
                <span className="text-gray-900 mt-1"><br/>{educationData.educationSystem}</span>
              </div>
            </div>        
          </div>

          <hr className="border-t border-gray-300 mb-4" />
        
          {/* Academic Performance Section */}
          <div className="mb-8">
            <h2 className="text-gray-800 text-lg font-semibold mb-4">
              Academic Performance Details
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="p-4">
                <span className="text-gray-800 text-base font-semibold">
                  Grading System
                </span>
                <span className="text-gray-900 mt-1"><br/>{educationData.gradingSystem}</span>
              </div>
        
              { educationData.gradingSystem !== 'Percentage' && 
                <div className="p-4">
                  <span className="text-gray-800 text-base font-semibold">
                    Total 
                    {educationData.gradingSystem === "CGPA Based" ? ' CGPA'
                      : educationData.gradingSystem === "Percentage" ? ' Percentage'
                      : educationData.gradingSystem === "Marks" ? ' Marks'
                      : null
                    }
                  </span>
                  <span className="text-gray-900 mt-1"><br/>{educationData.total}</span>
                </div>
              }
        
              <div className="p-4">
                <span className="text-gray-800 text-base font-semibold">
                  Obtained 
                  {educationData.gradingSystem === "CGPA Based" ? ' CGPA'
                    : educationData.gradingSystem === "Percentage" ? ' Percentage'
                    : educationData.gradingSystem === "Marks" ? ' Marks'
                    : null
                  }
                </span>
                <span className="text-gray-900 mt-1"><br/>
                  {educationData.obtained}{educationData.gradingSystem === 'Percentage' && '%'}
                </span>
              </div>
            </div>
          </div>
        
          {/* Action Buttons */}
          {/* <div className="flex justify-end">
            <button className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600">
              Close
            </button>
          </div> */}
        </div>
        </>
      }
    </div>
  );
}

export default EducationForm;